module.exports = __webpack_public_path__ + "components/weather-icon/static/nightshowers-fc0d0ddf81380c20af30937ce993df2d.svg";